export const openLinkInNewTab = href => {
	window.open(href);
};
